// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__hk7gx","chip__text":"Chip_chip__text__pfZPB","chip__icon":"Chip_chip__icon__PbFn9"};